'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory('tlCalendarDefaultConfig', function () {
  return {
    hideWeekends: false
  };
});
ngModule.directive('tlCalendar', function ($compile, tlCalendarDefaultConfig) {
  return {
    restrict: "E",
    replace: true,
    transclude: true,
    scope: true,
    template: '' + '<div class="tl-calendar">' + '   <table>' + '       <thead tl-calendar-header></thead>' + '       <tbody></tbody>' + '   </table>' + '   <div class="tl-calendar-tpl" ng-transclude></div>' + '</div>',
    link: function link($scope, $el, $attrs, ctrl) {
      var configAttr = $attrs.calendarConfig;
      $scope.$watch(configAttr, function (config) {
        if (config == null) {
          return;
        }
        ctrl.initialize(config);
      });
      $scope.$on("$destroy", function () {
        ctrl.dispose();
      });
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        headerCtrl = null,
        config = null,
        cellTranscludeFn = null,
        ui = {
          rows: [],
          body: $element.find("table tbody")
        };
      var setConfig = function setConfig(_config) {
        config = _.extend(angular.copy(tlCalendarDefaultConfig), _config);
      };
      var createRow = function createRow(rowIdx) {
        var row = $("<tr>").addClass(rowIdx % 2 ? "even" : "odd");
        row.appendTo(ui.body);
        return row;
      };
      ctrl.setHeaderCtrl = function (_headerCtrl) {
        headerCtrl = _headerCtrl;
      };
      ctrl.initialize = function (config) {
        setConfig(config);
        headerCtrl.construct();
        var cellTemplate = $("<td tl-calendar-cell>"),
          cellLinkFn = $compile(cellTemplate),
          today = moment(),
          calendarDate = moment(config.date || new Date()).startOf("month"),
          monthOfDate = calendarDate.month(),
          firstDay = calendarDate.clone().startOf("month").startOf("week"),
          lastDay = calendarDate.clone().endOf("month").endOf("week");
        var isWeekendDay = function isWeekendDay(m) {
          return m.day() === 6 || m.day() === 0;
        };
        if (config.hideWeekends && isWeekendDay(calendarDate)) {
          firstDay = calendarDate.clone().add(calendarDate.day() === 6 ? 2 : 1, "day");
        }
        var currentDay = firstDay.clone(),
          rowIdx = 0,
          currentRow = null,
          i = 0;
        var createCellScope = function createCellScope(currentDay) {
          var cellScope = $scope.$new();
          // TODO : inject other vars to scope.
          _.extend(cellScope, {
            $index: i,
            $date: currentDay.toDate(),
            rowIndex: rowIdx,
            isToday: currentDay.isSame(today, "day"),
            isWeekend: isWeekendDay(currentDay),
            previousMonth: currentDay.month() < monthOfDate,
            currentMonth: currentDay.month() === monthOfDate,
            nextMonth: currentDay.month() > monthOfDate,
            year: currentDay.year(),
            month: currentDay.month(),
            day: currentDay.date(),
            dayOfWeek: currentDay.day()
          });
          return cellScope;
        };
        while (currentDay.isBefore(lastDay)) {
          // monday -> we create a new row
          if (currentDay.day() === 1) {
            currentRow = createRow(rowIdx);
            rowIdx++;
          }
          if (config.hideWeekends && isWeekendDay(currentDay)) {
            currentDay.add(1, "day");
            i++;
            continue;
          }
          var cellScope = createCellScope(currentDay);
          cellLinkFn(cellScope, function (cell) {
            cell.appendTo(currentRow);
            cellTranscludeFn(cellScope, function (cellContent) {
              cell.append(cellContent);
            });
          });
          currentDay.add(1, "day");
          i++;
        }
      };
      ctrl.dispose = function () {
        cellTranscludeFn = null;
      };
      ctrl.setCellTranscludeFunction = function (transcludeFn) {
        cellTranscludeFn = transcludeFn;
      };
      ctrl.getConfig = function () {
        return config;
      };
    }
  };
});
ngModule.directive("tlCalendarCellTemplate", function () {
  return {
    restrict: "E",
    transclude: true,
    require: "^tlCalendar",
    link: function link($scope, $el, $attrs, calendarCtrl, transcludeFn) {
      calendarCtrl.setCellTranscludeFunction(transcludeFn);
    }
  };
});
ngModule.directive("tlCalendarCell", function () {
  return {
    restrict: "A",
    scope: true,
    link: function link($scope, $el, $attrs) {
      if ($scope.previousMonth) {
        $el.addClass("previous-month");
      }
      if ($scope.currentMonth) {
        $el.addClass("current-month");
      }
      if ($scope.nextMonth) {
        $el.addClass("next-month");
      }
      if ($scope.isToday) {
        $el.addClass("current-day");
      }
      if ($scope.isWeekend) {
        $el.addClass("weekend-day");
      }
    }
  };
});
ngModule.directive('tlCalendarHeader', function ($translate) {
  return {
    restrict: "A",
    require: ["tlCalendarHeader", "^tlCalendar"],
    replace: false,
    scope: true,
    link: function link($scope, $el, $attrs, controllers) {
      var headerCtrl = controllers[0];
      var calendarCtrl = controllers[1];
      calendarCtrl.setHeaderCtrl(headerCtrl);
      headerCtrl.setCalendarCtrl(calendarCtrl);
    },
    controller: function controller($scope, $element) {
      var ctrl = this,
        calendarCtrl = null;
      ctrl.setCalendarCtrl = function (_calendarCtrl) {
        calendarCtrl = _calendarCtrl;
      };
      ctrl.construct = function () {
        var config = calendarCtrl.getConfig();
        $element.empty();
        $element.append('<th>' + $translate('marche.history.indexations.calendar.Lun') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Mar') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Mer') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Jeu') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Ven') + '</th>');
        if (!config.hideWeekends) {
          $element.append('<th>' + $translate('marche.history.indexations.calendar.Sam') + '</th>' + '<th>' + $translate('marche.history.indexations.calendar.Dim') + '</th>');
        }
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/calendar/tl-calendar.js
// module id = 2928
// module chunks = 13